import { ErrorJson } from '../type/error_json';
import { html } from 'rune-ts';

export const preventEscapeErrorJson = <T extends ErrorJson>(json: T) => {
  return { ...json, message: json.message ? html.preventEscape(json.message) : undefined };
};
